import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Services from '../components/Services';
import SEO from '../components/SEO';

const ServicesPage = () => {
  return (
    <>
      <SEO 
        title="Services - CodeRidge | AI Automation, Cybersecurity, Cloud 3.0 & Managed IT"
        description="Intelligent automation and custom LLM workflows, resilient cybersecurity and zero trust, Cloud 3.0 migrations and cost optimization across AWS, Azure, and hybrid environments, plus 24/7 managed IT. Enterprise web and mobile engineering."
        keywords="LLM workflows, zero trust, threat hunting, AWS Azure hybrid cloud, managed IT 24/7, enterprise web development, mobile development, CodeRidge"
        url="https://coderidge.in/services"
      />
      <Navbar />
      <div style={{ paddingTop: '80px' }}>
        <Services />
      </div>
      <Footer />
    </>
  );
};

export default ServicesPage;










